module.exports = __webpack_public_path__ + "img/logo2.ddf5474e.png";